import React, { FC, useContext, useEffect } from "react";
import { CheckoutContext } from "v3/context/checkout";
import { PaymentContext } from "v3/context/payment";
import { TenantContext } from "v3/context/tenant";
import { ShippingStep } from "v3/components/checkout/Steps/ShippingStep";
import { ShippingMethodStep } from "v3/components/checkout/Steps/ShippingMethodStep";
import { StripeSteps } from "v3/components/checkout/Steps/StripeSteps";
import { CHECKOUT_STEPS } from "v3/types/checkout";
import { BraintreePaymentStep } from "./BraintreePaymentStep";
import { BraintreeReviewStep } from "./BraintreeReviewStep";

export const CheckoutSteps: FC = () => {
  const { tenant, isStripeTenant } = useContext(TenantContext);
  const { setPaymentIntentSecret } = useContext(PaymentContext);
  const { checkoutSession, step, transitionToStep } =
    useContext(CheckoutContext);

  const isInvoiceUser = !!checkoutSession?.activeAccount?.isInvoiced;
  const { shippingMethodsEnabled } = tenant?.checkout?.shippingOptions || {};
  const shouldRenderStripeSteps =
    step === CHECKOUT_STEPS.payment ||
    (step === CHECKOUT_STEPS.review && !!checkoutSession);

  useEffect(() => {
    if (
      step === CHECKOUT_STEPS.shipping ||
      step === CHECKOUT_STEPS.shippingMethod
    ) {
      setPaymentIntentSecret(null);
    }
  }, [setPaymentIntentSecret, step]);

  return (
    <>
      {step === CHECKOUT_STEPS.shipping && (
        <ShippingStep
          continueToNextStep={() =>
            transitionToStep(
              shippingMethodsEnabled
                ? CHECKOUT_STEPS.shippingMethod
                : CHECKOUT_STEPS.payment
            )
          }
        />
      )}

      {step === CHECKOUT_STEPS.shippingMethod && (
        <ShippingMethodStep
          continueToNextStep={() => transitionToStep(CHECKOUT_STEPS.payment)}
        />
      )}

      {/* BRAINTREE */}
      {(!isStripeTenant || isInvoiceUser) && (
        <>
          {step === CHECKOUT_STEPS.payment && (
            <BraintreePaymentStep
              continueToNextStep={() => transitionToStep(CHECKOUT_STEPS.review)}
            />
          )}
          {step === CHECKOUT_STEPS.review && (
            <BraintreeReviewStep
              editShip={() => transitionToStep(CHECKOUT_STEPS.shipping)}
              editPayment={() => transitionToStep(CHECKOUT_STEPS.payment)}
            />
          )}
        </>
      )}

      {/* STRIPE */}
      {isStripeTenant && shouldRenderStripeSteps && !isInvoiceUser && (
        <StripeSteps />
      )}
    </>
  );
};
